// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-button {
  font-family: "Roboto-Medium";
}

.px-16px {
  padding-left: 16px;
  padding-right: 16px;
}

.py-16px {
  padding-top: 16px;
  padding-bottom: 16px;
}

.p-16px {
  padding: 16px;
}

.pr-16px {
  padding-right: 16px !important;
  padding-inline-end: 16px !important;
}

.pl-16px {
  padding-left: 16px !important;
  padding-inline-start: 16px !important;
}

.pb-16px {
  padding-bottom: 16px;
}

.pt-16px {
  padding-top: 16px;
  --padding-top: 16px;
}

.m-0 {
  margin: 0 !important;
}

.p-0 {
  padding: 0 !important;
}

.d-f-a-c {
  align-items: center;
  display: flex;
}

.three-dots {
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 100%;
  height: 100%;
  white-space: nowrap;
}

.wrapper-door-status {
  position: relative;
  text-align: center;
  background-color: #f8f8fd;
  height: 100%;
}
.wrapper-door-status img {
  height: 90vh;
}
.wrapper-door-status .text-block {
  top: 15vh;
  position: absolute;
  width: 100%;
  padding: 0 30px;
}
.wrapper-door-status .text-block .door-label {
  font-size: 4.4rem;
  line-height: normal;
}
.wrapper-door-status .text-block h1.blue, .wrapper-door-status .text-block h2.blue {
  color: var(--vl-blue);
}
.wrapper-door-status .text-block h1.green, .wrapper-door-status .text-block h2.green {
  color: var(--vl-green);
}
.wrapper-door-status .text-block h1.red, .wrapper-door-status .text-block h2.red {
  color: var(--vl-red);
}
.wrapper-door-status .text-block h2 {
  color: lightgrey;
  margin-top: 18px;
}
.wrapper-door-status .bottom-block {
  padding-left: 16px;
  padding-right: 16px;
  position: absolute;
  width: 100%;
  bottom: 34px;
}
.wrapper-door-status .bottom-block .message {
  text-align: center;
  margin-bottom: 16px;
  color: var(--vl-black-font);
  font-family: "Roboto-Medium";
  font-size: 1rem;
  font-weight: 500;
}
.wrapper-door-status .close-btn {
  width: 51px;
  position: absolute;
  right: 0;
  top: var(--ion-safe-area-top);
  --background-hover: none;
}

.close-wrapper {
  display: flex;
  justify-content: flex-end;
}
.close-wrapper vl-icon {
  position: absolute;
  top: 30px;
  right: 30px;
}

.segment-wrapper {
  margin-bottom: 10px;
}

.contact-us {
  font-size: 12px;
  margin-top: 8px;
  font-family: "Roboto-Medium";
}

.reminder {
  font-weight: 500;
  font-size: 1.1rem;
  line-height: 1.5rem;
  color: var(--vl-black-font);
  font-family: "Roboto-Regular";
  padding-top: 35px;
  text-align: left;
  width: 100%;
  display: flex;
  justify-content: center;
}
.reminder ul {
  width: fit-content;
}
.reminder h5 {
  padding-bottom: 10px;
}

.checklist {
  list-style-type: none;
  padding-left: 16px;
}

.checklist li {
  margin-bottom: 10px;
}
.checklist li .check {
  color: transparent;
  text-shadow: 0 0 0 #2BA14D;
}
.checklist li .highlight {
  text-decoration: underline;
}

@media (max-width: 576px) {
  .text-block {
    top: 20vh;
  }
  .inner-content {
    max-height: 100vh !important;
  }
  img {
    height: 100vh;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/_vl-variables.scss","webpack://./src/app/modules/bookings/door-status/door-status.component.scss"],"names":[],"mappings":"AAgBA;EACE,4BAXc;ACJhB;;ADmBA;EACE,kBAZe;EAaf,mBAbe;ACHjB;;ADmBA;EACE,iBAjBe;EAkBf,oBAlBe;ACEjB;;ADmBA;EACE,aAtBe;ACMjB;;ADmBA;EACE,8BAAA;EACA,mCAAA;AChBF;;ADmBA;EACE,6BAAA;EACA,qCAAA;AChBF;;ADmBA;EACE,oBAAA;AChBF;;ADmBA;EACE,iBAAA;EACA,mBAAA;AChBF;;ADmBA;EACE,oBAAA;AChBF;;ADmBA;EACE,qBAAA;AChBF;;ADmBA;EACE,mBAAA;EACA,aAAA;AChBF;;ADmBA;EACE,cAAA;EACA,uBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AChBF;;AApDA;EACE,kBAAA;EACA,kBAAA;EACA,yBAAA;EACA,YAAA;AAuDF;AArDE;EACE,YAAA;AAuDJ;AApDE;EACE,SAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;AAsDJ;AArDI;EACE,iBAAA;EACA,mBAAA;AAuDN;AAnDM;EACE,qBAAA;AAqDR;AAlDM;EACE,sBAAA;AAoDR;AAjDM;EACE,oBAAA;AAmDR;AA/CI;EACE,gBAAA;EACA,gBAAA;AAiDN;AA5CE;EACE,kBDrCa;ECsCb,mBDtCa;ECuCb,kBAAA;EACA,WAAA;EACA,YAAA;AA8CJ;AA5CI;EACE,kBAAA;EACA,mBAAA;EACA,2BAAA;EACA,4BDnDU;ECoDV,eAAA;EACA,gBAAA;AA8CN;AA1CE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,6BAAA;EACA,wBAAA;AA4CJ;;AAxCA;EACE,aAAA;EACA,yBAAA;AA2CF;AA1CE;EACE,kBAAA;EACA,SAAA;EACA,WAAA;AA4CJ;;AAxCA;EACE,mBAAA;AA2CF;;AAxCA;EACE,eAAA;EACA,eAAA;EACA,4BDnFc;AC8HhB;;AAxCA;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,2BAAA;EACA,6BDzFe;EC0Ff,iBAAA;EACA,gBAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;AA2CF;AA1CE;EACE,kBAAA;AA4CJ;AA1CE;EACE,oBAAA;AA4CJ;;AAxCA;EACE,qBAAA;EACA,kBAAA;AA2CF;;AAzCA;EACE,mBAAA;AA4CF;AA3CE;EACE,kBAAA;EACA,0BAAA;AA6CJ;AA3CE;EACE,0BAAA;AA6CJ;;AAzCA;EACE;IACE,SAAA;EA4CF;EA1CA;IACE,4BAAA;EA4CF;EA1CA;IACE,aAAA;EA4CF;AACF","sourcesContent":["$red: #EB0000;\n$black: #262627;\n\n$font-path: \"~roboto-fontface/fonts/roboto/\";\n$font-format: 'woff';\n$roboto-bold: \"Roboto-Bold\";\n$roboto-medium: \"Roboto-Medium\";\n$roboto-light: \"Roboto-Light\";\n$roboto-regular: \"Roboto-Regular\";\n\n$global-padding: 16px;\n$global-padding-with-fixed-button: 108px;\n$toolbar-height: 70px;\n$modal-height: 425px;\n$edit-phone-email-modal-height: 325px;\n\nion-button {\n  font-family: $roboto-medium;\n}\n\n\n.px-16px {\n  padding-left: $global-padding;\n  padding-right: $global-padding;\n}\n\n.py-16px {\n  padding-top: $global-padding;\n  padding-bottom: $global-padding;\n}\n\n.p-16px {\n  padding: $global-padding;\n}\n\n.pr-16px {\n  padding-right: $global-padding !important;\n  padding-inline-end: $global-padding !important;\n}\n\n.pl-16px {\n  padding-left: $global-padding !important;\n  padding-inline-start: $global-padding !important;\n}\n\n.pb-16px {\n  padding-bottom: 16px;\n}\n\n.pt-16px {\n  padding-top: 16px;\n  --padding-top: 16px;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.d-f-a-c {\n  align-items: center;\n  display: flex;\n}\n\n.three-dots {\n  display: block;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  width: 100%;\n  height: 100%;\n  white-space: nowrap;\n}\n","@use \"/src/assets/scss/vl-variables\" as *;\n\n// .inner-content {\n  // max-height: 100vh !important;\n// }\n.wrapper-door-status {\n  position: relative;\n  text-align: center;\n  background-color: #f8f8fd;\n  height: 100%;\n\n  img {\n    height: 90vh;\n  }\n\n  .text-block {\n    top: 15vh;\n    position: absolute;\n    width: 100%;\n    padding: 0 30px;\n    .door-label {\n      font-size: 4.4rem;\n      line-height: normal;\n    }\n    h1, h2 {\n\n      &.blue {\n        color: var(--vl-blue);\n      }\n\n      &.green {\n        color: var(--vl-green);\n      }\n\n      &.red {\n        color: var(--vl-red);\n      }\n    }\n\n    h2 {\n      color: lightgrey;\n      margin-top: 18px;\n    }\n  }\n\n\n  .bottom-block {\n    padding-left: $global-padding;\n    padding-right: $global-padding;\n    position: absolute;\n    width: 100%;\n    bottom: 34px;\n\n    .message {\n      text-align: center;\n      margin-bottom: 16px;\n      color: var(--vl-black-font);\n      font-family: $roboto-medium;\n      font-size: 1rem;\n      font-weight: 500;\n    }\n  }\n\n  .close-btn {\n    width: 51px;\n    position: absolute;\n    right: 0;\n    top: var(--ion-safe-area-top);\n    --background-hover: none;\n  }\n}\n\n.close-wrapper {\n  display: flex;\n  justify-content: flex-end;\n  vl-icon {\n    position: absolute;\n    top: 30px;\n    right: 30px;\n  }\n}\n\n.segment-wrapper {\n  margin-bottom: 10px;\n}\n\n.contact-us {\n  font-size: 12px;\n  margin-top: 8px;\n  font-family: $roboto-medium;\n}\n\n.reminder {\n  font-weight: 500;\n  font-size: 1.1rem;\n  line-height: 1.5rem;\n  color: var(--vl-black-font);\n  font-family: $roboto-regular;\n  padding-top: 35px;\n  text-align: left;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  ul {\n    width: fit-content;\n  }\n  h5 {\n    padding-bottom: 10px;\n  }\n}\n\n.checklist {\n  list-style-type: none;\n  padding-left: 16px;\n}\n.checklist li {\n  margin-bottom: 10px;\n  .check {\n    color: transparent;\n    text-shadow: 0 0 0 #2BA14D;\n  }\n  .highlight {\n    text-decoration: underline;\n  }\n}\n\n@media (max-width: 576px) {\n  .text-block {\n    top: 20vh;\n  }\n  .inner-content {\n    max-height: 100vh !important;\n  }\n  img {\n    height: 100vh;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
